
<form class="table-filter" [formGroup]="formGroup" (ngSubmit)="submit()">
    <button mat-raised-button color="primary" type="button" class="garantor-button mini open-filters-button" (click)="openFilters = !openFilters">
        <mat-icon class="filter-icon">filter_list</mat-icon>
        {{ openFilters ? 'Ocultar búsqueda' : 'Ver búsqueda' }}
    </button>
    <ng-container *ngFor="let filter of filters">
        <mat-form-field class="garantor-form-field" appearance="outline" *ngIf="openFilters">
            <mat-label>{{ filter.description }}</mat-label>
            <input matInput [formControlName]="filter.key" *ngIf="filter.type === 'STRING'">
            <input matInput [formControlName]="filter.key" type="number" *ngIf="filter.type === 'NUMBER'">
            <input matInput [formControlName]="filter.key" [matDatepicker]="picker" *ngIf="filter.type === 'DATE'">
            <input matInput [formControlName]="filter.key" inputmode="numeric" (keypress)="onKeyPressDigits($event)" (paste)="onPasteDigits($event, filter.key)" *ngIf="filter.type === 'DIGITS'">
            <ng-container *ngIf="filter.type === 'AUTOCOMPLETE'">
                <input matInput
                       [formControl]="displayControls[filter.key]"
                       [matAutocomplete]="auto"
                       (focus)="onAutocompleteFocus(filter)"
                       (input)="onAutocompleteInput(filter, $event.target['value'])">
                <mat-autocomplete #auto
                                  [displayWith]="displayAutocomplete"
                                  (optionSelected)="onAutocompleteSelect(filter.key, $event.option.value)">
                    <mat-option *ngFor="let opt of autocompleteOptions[filter.key]" [value]="opt">
                        {{ opt.descripcion }}
                    </mat-option>
                </mat-autocomplete>
            </ng-container>
            <mat-icon matSuffix *ngIf="filter.type === 'AUTOCOMPLETE'" class="autocomplete-arrow-icon">arrow_drop_down</mat-icon>
            <mat-select [formControlName]="filter.key" *ngIf="filter.type === 'ENUM'">
                <mat-option [value]="undefined">- Sin filtro -</mat-option>
                <mat-option *ngFor="let option of filter.availableOptions" [value]="option.codigo">
                    {{ option.descripcion }}
                </mat-option>
            </mat-select>
            <mat-datepicker-toggle matSuffix [for]="picker" *ngIf="filter.type === 'DATE'"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </ng-container>
    <button mat-raised-button color="accent" class="garantor-button mini search-button" *ngIf="openFilters">
        Buscar
    </button>
    <button mat-button color="primary" class="garantor-button mini search-button clear-filter" *ngIf="openFilters" (click)="clearFilters()">
        Limpiar filtros
    </button>
</form>
